<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.ImagesSpaces.edit") }}</h4>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">

          <!-- Start:: Name Input -->
          <base-input col="6" type="text" :placeholder="$t('PLACEHOLDERS.nameAr')" v-model.trim="data.nameAr" required/>
          <!-- End:: Name Input -->

          <!-- Start:: Name Input -->
          <base-input col="6" type="text" :placeholder="$t('PLACEHOLDERS.nameEn')" v-model.trim="data.nameEn" required/>
          <!-- End:: Name Input -->
          <!-- Start:: Start Input -->
          <base-input col="6" type="date" :placeholder="$t('TABLES.ImagesSpaces.startDate')" v-model.trim="data.start" required/>
          <base-input col="6" type="date" :placeholder="$t('TABLES.ImagesSpaces.endDate')" v-model.trim="data.end" required/>
          <!-- End:: Start Input -->
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input col="6" identifier="image" :preSelectedImage="data.image.path"
                                    @selectImage="selectImage" :placeholder="$t('PLACEHOLDERS.image')" required />
          <!-- End:: Image Upload Input -->
          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch color="green" :label="data.active ? $t('PLACEHOLDERS.active') : $t('PLACEHOLDERS.notActive')"
                      v-model="data.active" hide-details ></v-switch>
          </div>

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button class="mt-2" styleType="primary_btn" :btnText="$t('BUTTONS.save')" :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest" />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>

export default {
  name: "EditSlider",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      sportList: [],
      // Start:: Data Collection To Send
      data: {
        nameAr: null,
        nameEn: null,
        start: null,
        end: null,
        active: true,
        image: {
          path: null,
          file: null,
        },
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
  },

  methods: {
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      console.log(selectedImage);
      this.data.image = selectedImage;
    },
    
    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.data.nameAr) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameAr"));
        return;
      } else if (!this.data.nameEn) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.nameEn"));
        return;
      } else if (!this.data.start) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.start"));
        return;
      } else if (!this.data.end) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.end"));
        return;
      } 
      // else if (!this.data.image.file) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.image"));
      //   return;
      // }
      else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
  REQUEST_DATA.append("name[ar]", this.data.nameAr);
  REQUEST_DATA.append("name[en]", this.data.nameEn);
  REQUEST_DATA.append("start", this.data.start);
  REQUEST_DATA.append("end", this.data.end);
  if (this.data.image.file) {
    REQUEST_DATA.append("image", this.data.image.file);
  }
      REQUEST_DATA.append("is_active", +this.data.active);
      REQUEST_DATA.append("_method", "PUT");
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `sliders/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/sliders/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },

    // start show data
    async showSlider() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `sliders/${this.$route.params.id}`,
        });
        this.data.nameAr = res.data.data.Slider.trans.name.ar;
        this.data.nameEn = res.data.data.Slider.trans.name.en;
        this.data.active = res.data.data.Slider.is_active;
        this.data.image.path = res.data.data.Slider.image;
        this.data.start = res.data.data.Slider.start;
        this.data.end = res.data.data.Slider.end;
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // end show data

  },

  created() {
    // Start:: Fire Methods
    this.showSlider();
    // End:: Fire Methods
  },
};
</script>
